import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { instalarDeshacerEnCampos } from './deshacerEnCampos';

// Cada pantalla se descarga solo cuando hace falta (carga diferida): la página pública de turnos
// online y la Pantalla de Espera no descargan el sistema completo, así abren rápido (sobre todo
// en celulares con datos móviles). El personal descarga el sistema completo como siempre.
const App = lazy(() => import('./App'));
const PantallaEspera = lazy(() => import('./PantallaEspera'));
const TurnosOnline = lazy(() => import('./TurnosOnline'));
const SubirDesdeCelular = lazy(() => import('./SubirDesdeCelular'));

// Mientras se descarga la pantalla: una ruedita simple, sin depender de ninguna librería.
function Cargando() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', color: '#1a5276' }}>
      <div
        style={{
          width: 36, height: 36, border: '4px solid #d6eaf8', borderTopColor: '#1a5276',
          borderRadius: '50%', animation: 'girar-carga 0.9s linear infinite',
        }}
      />
      <style>{'@keyframes girar-carga { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}

// La pantalla de sala de espera (/pantalla-espera) corre sin login, pensada para
// el TV stick de la sala de espera. Por eso se decide ACÁ, antes de montar <App />,
// que es donde vive toda la lógica de Firebase Auth (onAuthStateChanged, <Login />).
// Si el chequeo se hiciera adentro de App, esa lógica de Auth ya se habría
// ejecutado y pediría login igual.
function Raiz() {
  if (window.location.pathname === '/pantalla-espera') {
    return <PantallaEspera />;
  }
  // Turnos online (página pública para pacientes, sin login): /turnos-online, o cualquier
  // dirección de un subdominio "turnos." (ej. turnos.carosellacardiologia.com).
  if (window.location.pathname.startsWith('/turnos-online') || window.location.hostname.startsWith('turnos.')) {
    return <TurnosOnline />;
  }
  // Página del celular para subir la foto de un comprobante a una solicitud de factura (se llega
  // escaneando el QR de la ventana en la PC). Sin login: ver SubirDesdeCelular.js.
  if (window.location.pathname.startsWith('/subir/')) {
    return <SubirDesdeCelular />;
  }
  return <App />;
}

// Ctrl+Z / Ctrl+Y en todos los campos de texto, en todas las pantallas (ver deshacerEnCampos.js).
instalarDeshacerEnCampos(document);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<Cargando />}>
      <Raiz />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
